/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const RESERVE_PRODUCE_TITLE = (
    <FormattedMessage
        id='building_reserve_produce.title'
        defaultMessage='Подготовка резервов'
    />
)

export const RESERVE_PRODUCE_COST = (
    <FormattedMessage
        id='building_reserve_produce.cost'
        defaultMessage='Стоимость подготовки'
    />
)

export const RESERVE_PRODUCE_DURATION = (
    <FormattedMessage
        id='building_reserve_produce.duration'
        defaultMessage='Время подготовки'
    />
)

export const RESERVE_PRODUCE_SUBMIT = (
    <FormattedMessage
        id='building_reserve_produce.submit'
        defaultMessage='Подготовить'
    />
)

export const RESERVE_PRODUCE_WARNING = (
    <FormattedMessage
        id='building_reserve_produce.warning'
        defaultMessage='Подготавливать резервы могут командующий, его заместители и офицеры штаба.'
    />
)

export const TOTAL_DURATION_TOOLTIP_CONTENT = (timeNode) => (
    <FormattedMessage
        id='building_reserve_produce.total_duration_tooltip_content'
        defaultMessage='Все резервы будут готовы {timeNode}'
        values={{
            timeNode,
        }}
    />
)

export const TOTAL_DURATION_TOOLTIP_ID = 'reserveProduceTimeLeft'
export const INDUSTRIAL_RESOURCE_TOOLTIP_ID = 'notEnoughIndustrialResource'



// WEBPACK FOOTER //
// ./containers/BuildingCard/components/ReserveProduce/constants.jsx